import React from 'react';
import {
    Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { beautifyNumber } from '../../../Utils/FormatNumber';
import { snapshotLineTotal } from '../documentLifecycle.js';

const scrollbarSx = {
    scrollbarWidth: 'thin',
    scrollbarColor: '#d8daf2 transparent',
    '&::-webkit-scrollbar': { width: 6, height: 6 },
    '&::-webkit-scrollbar-track': { background: 'transparent' },
    '&::-webkit-scrollbar-thumb': { background: '#d8daf2', borderRadius: 999 },
};

/** Same line fields as GenerateDocumentModal's snapshot table (makat, name, qty, price, discount, total). */
const LinkDocumentItemsPanel = ({ items, loading, error, emptyLabel }) => {
    const { t } = useTranslation();
    const rows = Array.isArray(items) ? items : [];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5 }}>
                <CircularProgress size={22} />
            </Box>
        );
    }
    if (error) {
        return <Typography variant="body2" color="error">{error}</Typography>;
    }
    if (rows.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                {emptyLabel || t('LinkDocumentsNoItemSnapshot')}
            </Typography>
        );
    }

    const total = rows.reduce((sum, item) => sum + snapshotLineTotal(item), 0);

    return (
        <TableContainer sx={{ maxHeight: 220, overflow: 'auto', ...scrollbarSx }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">{t('Makat')}</TableCell>
                        <TableCell align="center">{t('Name')}</TableCell>
                        <TableCell align="center">{t('Quantity')}</TableCell>
                        <TableCell align="center">{t('Price')}</TableCell>
                        <TableCell align="center">{t('Discount')} (%)</TableCell>
                        <TableCell align="center">{t('Total')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((item, index) => {
                        const price = Number(item.price ?? item.Price) || 0;
                        const quantity = Number(item.quantity ?? item.Quantity) || 0;
                        const discount = Number(item.discount ?? item.Discount) || 0;
                        return (
                            <TableRow key={item.id || item.Id || index}>
                                <TableCell align="center">{item.makat || item.Makat || '—'}</TableCell>
                                <TableCell align="center" sx={{ maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {item.name || item.Name || '—'}
                                </TableCell>
                                <TableCell align="center">{quantity}</TableCell>
                                <TableCell align="center">{beautifyNumber(price)}</TableCell>
                                <TableCell align="center">{discount}</TableCell>
                                <TableCell align="center">{beautifyNumber(snapshotLineTotal(item))}</TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableCell colSpan={5} align="right" sx={{ fontWeight: 700 }}>{t('Total')}</TableCell>
                        <TableCell align="center" sx={{ fontWeight: 700 }}>{beautifyNumber(total)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LinkDocumentItemsPanel;
